/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from rtu-ui-v2/schemas/common/Common.yaml
import { PartiallyConstructible } from '../../utils/utils';
/**
Value palette describing the colors of the scanner screens.
*/
export class Palette extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<Palette>`} */
    constructor(source = {}) {
        super();
        /**
          The primary color used for enabled elements.
          
          Default is "#C8193C"
          */
        this.sbColorPrimary = '#C8193C';
        /**
          The primary color used for disabled elements.
          
          Default is "#F5F5F5"
          */
        this.sbColorPrimaryDisabled = '#F5F5F5';
        /**
          The color used to convey a negative meaning.
          
          Default is "#FF3737"
          */
        this.sbColorNegative = '#FF3737';
        /**
          The color used to convey a positive meaning.
          
          Default is "#4EFFB4"
          */
        this.sbColorPositive = '#4EFFB4';
        /**
          The color used to convey warnings.
          
          Default is "#FFCE5C"
          */
        this.sbColorWarning = '#FFCE5C';
        /**
          The secondary color used for enabled elements.
          
          Default is "#FFEDEE"
          */
        this.sbColorSecondary = '#FFEDEE';
        /**
          The secondary color used for disabled elements.
          
          Default is "#F5F5F5"
          */
        this.sbColorSecondaryDisabled = '#F5F5F5';
        /**
          The color used for displaying elements on top of the primary color.
          
          Default is "#FFFFFF"
          */
        this.sbColorOnPrimary = '#FFFFFF';
        /**
          The color used for displaying elements on top of the secondary color.
          
          Default is "#C8193C"
          */
        this.sbColorOnSecondary = '#C8193C';
        /**
          The color used for surfaces.
          
          Default is "#FFFFFF"
          */
        this.sbColorSurface = '#FFFFFF';
        /**
          The color used for outlines.
          
          Default is "#EFEFEF"
          */
        this.sbColorOutline = '#EFEFEF';
        /**
          The alternative color used on top of surfaces.
          
          Default is "#707070"
          */
        this.sbColorOnSurfaceVariant = '#707070';
        /**
          The color used on top of surfaces.
          
          Default is "#000000"
          */
        this.sbColorOnSurface = '#000000';
        /**
          The color with a low alpha (transparency) value used for certain surfaces.
          
          Default is "#00000026"
          */
        this.sbColorSurfaceLow = '#00000026';
        /**
          The color with a high alpha (transparency) value used for certain surfaces.
          
          Default is "#0000007A"
          */
        this.sbColorSurfaceHigh = '#0000007A';
        /**
          The color with a very high alpha (transparency) value used to fill certain overlays.
          
          Default is "#000000A3"
          */
        this.sbColorModalOverlay = '#000000A3';
        if (source.sbColorPrimary !== undefined) {
            this.sbColorPrimary = source.sbColorPrimary;
        }
        if (source.sbColorPrimaryDisabled !== undefined) {
            this.sbColorPrimaryDisabled = source.sbColorPrimaryDisabled;
        }
        if (source.sbColorNegative !== undefined) {
            this.sbColorNegative = source.sbColorNegative;
        }
        if (source.sbColorPositive !== undefined) {
            this.sbColorPositive = source.sbColorPositive;
        }
        if (source.sbColorWarning !== undefined) {
            this.sbColorWarning = source.sbColorWarning;
        }
        if (source.sbColorSecondary !== undefined) {
            this.sbColorSecondary = source.sbColorSecondary;
        }
        if (source.sbColorSecondaryDisabled !== undefined) {
            this.sbColorSecondaryDisabled = source.sbColorSecondaryDisabled;
        }
        if (source.sbColorOnPrimary !== undefined) {
            this.sbColorOnPrimary = source.sbColorOnPrimary;
        }
        if (source.sbColorOnSecondary !== undefined) {
            this.sbColorOnSecondary = source.sbColorOnSecondary;
        }
        if (source.sbColorSurface !== undefined) {
            this.sbColorSurface = source.sbColorSurface;
        }
        if (source.sbColorOutline !== undefined) {
            this.sbColorOutline = source.sbColorOutline;
        }
        if (source.sbColorOnSurfaceVariant !== undefined) {
            this.sbColorOnSurfaceVariant = source.sbColorOnSurfaceVariant;
        }
        if (source.sbColorOnSurface !== undefined) {
            this.sbColorOnSurface = source.sbColorOnSurface;
        }
        if (source.sbColorSurfaceLow !== undefined) {
            this.sbColorSurfaceLow = source.sbColorSurfaceLow;
        }
        if (source.sbColorSurfaceHigh !== undefined) {
            this.sbColorSurfaceHigh = source.sbColorSurfaceHigh;
        }
        if (source.sbColorModalOverlay !== undefined) {
            this.sbColorModalOverlay = source.sbColorModalOverlay;
        }
    }
}
/**
Configuration of the text field appearance.
*/
export class StyledText extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<StyledText>`} */
    constructor(source = {}) {
        super();
        /**
          Determines whether the text field is visible or not.
          
          Default is true
          */
        this.visible = true;
        /**
          The value of the text field.
          
          Default is ""
          */
        this.text = '';
        /**
          The text color.
          
          Default is "#FFFFFF"
          */
        this.color = '#FFFFFF';
        /**
          Determines whether to enable drop shadows for the text.
          
          Default is false
          */
        this.useShadow = false;
        if (source.visible !== undefined) {
            this.visible = source.visible;
        }
        if (source.text !== undefined) {
            this.text = source.text;
        }
        if (source.color !== undefined) {
            this.color = source.color;
        }
        if (source.useShadow !== undefined) {
            this.useShadow = source.useShadow;
        }
    }
}
/**
Configuration of the icon appearance.
*/
export class IconStyle extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<IconStyle>`} */
    constructor(source = {}) {
        super();
        /**
          Determines whether the icon is visible or not.
          
          Default is true
          */
        this.visible = true;
        /**
          The icon color.
          
          Default is "#FFFFFF"
          */
        this.color = '#FFFFFF';
        if (source.visible !== undefined) {
            this.visible = source.visible;
        }
        if (source.color !== undefined) {
            this.color = source.color;
        }
    }
}
/**
Configuration of the icon appearance on a button.
*/
export class IconButton extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<IconButton>`} */
    constructor(source = {}) {
        super();
        /**
          Determines whether the icon is visible on the button.
          
          Default is true
          */
        this.visible = true;
        /**
          The icon color.
          
          Default is "#FFFFFF"
          */
        this.color = '#FFFFFF';
        /**
          The text to be read when the button is selected through accessibility mode.
          
          Default is ""
          */
        this.accessibilityDescription = '';
        if (source.visible !== undefined) {
            this.visible = source.visible;
        }
        if (source.color !== undefined) {
            this.color = source.color;
        }
        if (source.accessibilityDescription !== undefined) {
            this.accessibilityDescription = source.accessibilityDescription;
        }
    }
}
/**
Configuration of the polygon appearance.
*/
export class PolygonStyle extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<PolygonStyle>`} */
    constructor(source = {}) {
        super();
        /**
          The color of the polygon outline.
          
          Default is "#FFFFFFFF"
          */
        this.strokeColor = '#FFFFFFFF';
        /**
          The fill color of the polygon.
          
          Default is "#FFFFFF30"
          */
        this.fillColor = '#FFFFFF30';
        /**
          The width of the polygon outline in dp.
          
          Default is 2.0
          */
        this.strokeWidth = 2.0;
        /**
          The corner radius of the polygon in dp.
          
          Default is 0.0
          */
        this.cornerRadius = 0.0;
        if (source.strokeColor !== undefined) {
            this.strokeColor = source.strokeColor;
        }
        if (source.fillColor !== undefined) {
            this.fillColor = source.fillColor;
        }
        if (source.strokeWidth !== undefined) {
            this.strokeWidth = source.strokeWidth;
        }
        if (source.cornerRadius !== undefined) {
            this.cornerRadius = source.cornerRadius;
        }
    }
}
/**
Configuration of the background appearance for buttons and hints.
*/
export class BackgroundStyle extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<BackgroundStyle>`} */
    constructor(source = {}) {
        super();
        /**
          The color of the outline.
          
          Default is "#FFFFFFFF"
          */
        this.strokeColor = '#FFFFFFFF';
        /**
          The fill color.
          
          Default is "#FFFFFF30"
          */
        this.fillColor = '#FFFFFF30';
        /**
          The width of the outline in dp.
          
          Default is 2.0
          */
        this.strokeWidth = 2.0;
        if (source.strokeColor !== undefined) {
            this.strokeColor = source.strokeColor;
        }
        if (source.fillColor !== undefined) {
            this.fillColor = source.fillColor;
        }
        if (source.strokeWidth !== undefined) {
            this.strokeWidth = source.strokeWidth;
        }
    }
}
/**
Configuration of the appearance for foreground elements (e.g. text and/or icons, etc).
*/
export class ForegroundStyle extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<ForegroundStyle>`} */
    constructor(source = {}) {
        super();
        /**
          Determines whether the icon is visible or not.
          
          Default is true
          */
        this.iconVisible = true;
        /**
          The color used for foreground elements.
          
          Default is "#FFFFFF"
          */
        this.color = '#FFFFFF';
        /**
          Determines whether to use drop shadows for foreground elements.
          
          Default is false
          */
        this.useShadow = false;
        if (source.iconVisible !== undefined) {
            this.iconVisible = source.iconVisible;
        }
        if (source.color !== undefined) {
            this.color = source.color;
        }
        if (source.useShadow !== undefined) {
            this.useShadow = source.useShadow;
        }
    }
}
/**
Configuration of the badge.
*/
export class BadgeStyle extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<BadgeStyle>`} */
    constructor(source = {}) {
        super();
        /**
          Determines whether the badge is visible or not.
          
          Default is true
          */
        this.visible = true;
        /**
          Configuration of the background appearance for the badge.
          */
        this.background = new BackgroundStyle({});
        /**
          The color of the badge's foreground (icon, text).
          
          Default is "?sbColorOnSurface"
          */
        this.foregroundColor = '?sbColorOnSurface';
        if (source.visible !== undefined) {
            this.visible = source.visible;
        }
        if (source.background !== undefined) {
            this.background = new BackgroundStyle(source.background);
        }
        if (source.foregroundColor !== undefined) {
            this.foregroundColor = source.foregroundColor;
        }
    }
}
/**
Configuration of the round button.
*/
export class RoundButton extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<RoundButton>`} */
    constructor(source = {}) {
        super();
        /**
          Determines whether the button is visible or not.
          
          Default is true
          */
        this.visible = true;
        /**
          The text to be read when the button is selected through accessibility mode.
          
          Default is ""
          */
        this.accessibilityDescription = '';
        /**
          The color of the button's background.
          
          Default is "#0000007A"
          */
        this.backgroundColor = '#0000007A';
        /**
          The color of the button's foreground (icon, text).
          
          Default is "#FFFFFF"
          */
        this.foregroundColor = '#FFFFFF';
        /**
          The color of the button's background when the button is active (selected, toggled).
          
          Default is "#FFCE5C"
          */
        this.activeBackgroundColor = '#FFCE5C';
        /**
          The color of the button's foreground (icon, text) when the button is active (selected, toggled).
          
          Default is "#1C1B1F"
          */
        this.activeForegroundColor = '#1C1B1F';
        if (source.visible !== undefined) {
            this.visible = source.visible;
        }
        if (source.accessibilityDescription !== undefined) {
            this.accessibilityDescription = source.accessibilityDescription;
        }
        if (source.backgroundColor !== undefined) {
            this.backgroundColor = source.backgroundColor;
        }
        if (source.foregroundColor !== undefined) {
            this.foregroundColor = source.foregroundColor;
        }
        if (source.activeBackgroundColor !== undefined) {
            this.activeBackgroundColor = source.activeBackgroundColor;
        }
        if (source.activeForegroundColor !== undefined) {
            this.activeForegroundColor = source.activeForegroundColor;
        }
    }
}
/**
Configuration of the button with a badge.
*/
export class BadgedButton extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<BadgedButton>`} */
    constructor(source = {}) {
        super();
        /**
          The color of the badge's background.
          
          Default is "#FFFFFF"
          */
        this.badgeBackgroundColor = '#FFFFFF';
        /**
          The color of the badge's foreground (icon, text).
          
          Default is "#C8193C"
          */
        this.badgeForegroundColor = '#C8193C';
        /**
          Determines whether the button is visible or not.
          
          Default is true
          */
        this.visible = true;
        /**
          The color of the button's background.
          
          Default is "#0000007A"
          */
        this.backgroundColor = '#0000007A';
        /**
          The color of the button's foreground (icon, text).
          
          Default is "#FFFFFF"
          */
        this.foregroundColor = '#FFFFFF';
        /**
          The color of the button's background when the button is active (selected, toggled).
          
          Default is "#FFCE5C"
          */
        this.activeBackgroundColor = '#FFCE5C';
        /**
          The color of the button's foreground (icon, text) when the button is active (selected, toggled).
          
          Default is "#1C1B1F"
          */
        this.activeForegroundColor = '#1C1B1F';
        if (source.badgeBackgroundColor !== undefined) {
            this.badgeBackgroundColor = source.badgeBackgroundColor;
        }
        if (source.badgeForegroundColor !== undefined) {
            this.badgeForegroundColor = source.badgeForegroundColor;
        }
        if (source.visible !== undefined) {
            this.visible = source.visible;
        }
        if (source.backgroundColor !== undefined) {
            this.backgroundColor = source.backgroundColor;
        }
        if (source.foregroundColor !== undefined) {
            this.foregroundColor = source.foregroundColor;
        }
        if (source.activeBackgroundColor !== undefined) {
            this.activeBackgroundColor = source.activeBackgroundColor;
        }
        if (source.activeForegroundColor !== undefined) {
            this.activeForegroundColor = source.activeForegroundColor;
        }
    }
}
/**
Configuration of the button.
*/
export class ButtonConfiguration extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<ButtonConfiguration>`} */
    constructor(source = {}) {
        super();
        /**
          Determines whether the button is visible or not.
          
          Default is true
          */
        this.visible = true;
        /**
          The text to be displayed on the button.
          
          Default is ""
          */
        this.text = '';
        /**
          The text to be read when the button is selected through accessibility mode.
          
          Default is ""
          */
        this.accessibilityDescription = '';
        /**
          Configuration of the background appearance for the button.
          */
        this.background = new BackgroundStyle({});
        /**
          Configuration of the appearance for foreground elements (e.g. text and/or icons, etc) of the button.
          */
        this.foreground = new ForegroundStyle({});
        if (source.visible !== undefined) {
            this.visible = source.visible;
        }
        if (source.text !== undefined) {
            this.text = source.text;
        }
        if (source.accessibilityDescription !== undefined) {
            this.accessibilityDescription = source.accessibilityDescription;
        }
        if (source.background !== undefined) {
            this.background = new BackgroundStyle(source.background);
        }
        if (source.foreground !== undefined) {
            this.foreground = new ForegroundStyle(source.foreground);
        }
    }
}
/**
Configuration for the popup menu items.
*/
export class PopupMenuItem extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<PopupMenuItem>`} */
    constructor(source = {}) {
        super();
        /**
          The text to be displayed on the button.
          */
        this.title = new StyledText({});
        /**
          The text to be read when the button is selected through accessibility mode.
          
          Default is ""
          */
        this.accessibilityDescription = '';
        /**
          Configuration of the icon appearance.
          */
        this.icon = new IconStyle({});
        if (source.title !== undefined) {
            this.title = new StyledText(source.title);
        }
        if (source.accessibilityDescription !== undefined) {
            this.accessibilityDescription = source.accessibilityDescription;
        }
        if (source.icon !== undefined) {
            this.icon = new IconStyle(source.icon);
        }
    }
}
/**
Configuration of the button located on a bar.
*/
export class BarButtonConfiguration extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<BarButtonConfiguration>`} */
    constructor(source = {}) {
        super();
        /**
          Determines whether the button is visible or not.
          
          Default is true
          */
        this.visible = true;
        /**
          The text to be displayed on the button.
          */
        this.title = new StyledText({});
        /**
          The text to be read when the button is selected through accessibility mode.
          
          Default is ""
          */
        this.accessibilityDescription = '';
        /**
          Configuration of the background appearance for the button.
          */
        this.background = new BackgroundStyle({});
        /**
          Configuration of the icon appearance.
          */
        this.icon = new IconStyle({});
        if (source.visible !== undefined) {
            this.visible = source.visible;
        }
        if (source.title !== undefined) {
            this.title = new StyledText(source.title);
        }
        if (source.accessibilityDescription !== undefined) {
            this.accessibilityDescription = source.accessibilityDescription;
        }
        if (source.background !== undefined) {
            this.background = new BackgroundStyle(source.background);
        }
        if (source.icon !== undefined) {
            this.icon = new IconStyle(source.icon);
        }
    }
}
export const OrientationLockModeValues = ['NONE', 'PORTRAIT', 'LANDSCAPE'];
export const CameraPreviewModeValues = ['FIT_IN', 'FILL_IN'];
export const SoundTypeValues = ['MODERN_BEEP', 'CLASSIC_BEEP'];
/**
Configuration for the sound.
*/
export class Sound extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<Sound>`} */
    constructor(source = {}) {
        super();
        /**
          Determine whether the beep sound should be enabled or not when a barcode is detected.
          
          Default is true
          */
        this.successBeepEnabled = true;
        /**
          Determines the successful detection sound.
          
          Default is MODERN_BEEP
          */
        this.soundType = 'MODERN_BEEP';
        if (source.successBeepEnabled !== undefined) {
            this.successBeepEnabled = source.successBeepEnabled;
        }
        if (source.soundType !== undefined) {
            this.soundType = source.soundType;
        }
    }
}
/**
Configure the vibration.
*/
export class Vibration extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<Vibration>`} */
    constructor(source = {}) {
        super();
        /**
          Determine whether vibration should be enabled or not when a barcode is detected.
          
          Default is false
          */
        this.enabled = false;
        if (source.enabled !== undefined) {
            this.enabled = source.enabled;
        }
    }
}
/**
Configuration of timeouts.
*/
export class Timeouts extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<Timeouts>`} */
    constructor(source = {}) {
        super();
        /**
          Sets the length of time, in milliseconds, when the scanner should auto close. Default is 0 (disabled).
          
          Default is 0
          */
        this.autoCancelTimeout = 0;
        /**
          Sets the length of time, in milliseconds, that the first scan will be delayed by. Default is 0 (disabled).
          
          Default is 0
          */
        this.initialScanDelay = 0;
        if (source.autoCancelTimeout !== undefined) {
            this.autoCancelTimeout = source.autoCancelTimeout;
        }
        if (source.initialScanDelay !== undefined) {
            this.initialScanDelay = source.initialScanDelay;
        }
    }
}
/**
Represents the insets of a rectangle.
*/
export class EdgeInsets extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<EdgeInsets>`} */
    constructor(source = {}) {
        super();
        /**
          The top inset.
          
          Default is 0.0
          */
        this.top = 0.0;
        /**
          The left inset.
          
          Default is 0.0
          */
        this.left = 0.0;
        /**
          The bottom inset.
          
          Default is 0.0
          */
        this.bottom = 0.0;
        /**
          The right inset.
          
          Default is 0.0
          */
        this.right = 0.0;
        if (source.top !== undefined) {
            this.top = source.top;
        }
        if (source.left !== undefined) {
            this.left = source.left;
        }
        if (source.bottom !== undefined) {
            this.bottom = source.bottom;
        }
        if (source.right !== undefined) {
            this.right = source.right;
        }
    }
}
//# sourceMappingURL=Common.js.map